import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TextField } from '@/components/functional/Form/TextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { WithAnnotationText } from '@/components/ui/Typography/Body/WithAnnotationText';
import { validatePasswordInput } from '@/utils/validate/resources/password/passwordReset';
/**
 * パスワード再設定 パスワード
 */
export const PasswordResetEditPasswordField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: className, commentText: _jsx(WithAnnotationText, Object.assign({ color: 'none', size: 'none' }, { children: "\u534A\u89D2\u82F1\u6570\u5B57\u30FB\u8A18\u53F7\u306E\u307F\u30018\u6587\u5B57\u4EE5\u4E0A" })), labelText: '新しいパスワード' }, { children: _jsx(TextField, { inputProps: { autoComplete: 'off' }, name: name, type: 'password', validate: validatePasswordInput }) })));
};
